import { InferValueTypes } from 'types/commonTypes';
import { iUiStore } from 'types/ui';

import * as action from './actions';
import * as actionTypes from './actionTypes';

export const initialState: iUiStore = {
    isOpenSidebar: false,
    isConnectionLost: false,
};

type ActionType = ReturnType<InferValueTypes<typeof action>>;

const uiReducer = (state = initialState, action: ActionType) => {
    switch (action.type) {
        case actionTypes.SET_OPEN_SIDEBAR:
            return { ...state, isOpenSidebar: action.payload };

        case actionTypes.SET_CONNECTION_LOST:
            return { ...state, isConnectionLost: action.payload };

        default:
            return state;
    }
};

export default uiReducer;
